import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import RotateLeft from './img/RotateLeft.svg'
import RotateRight from './img/RotateRight.svg'

export function OrientationControlBlock(props) {
  const {t} = useTranslation();

  const inc = () => {

    //if(this.props.solution == null){
      props.incGelOrientation({id: props.id})
    // } else {
    //   this.makeToast(
    //     "WARNING",
    //     "You cannot rotate the gel once buffer has been added to the box.",
    //     "Buffer in gel box!"
    //   );
    // }

  }
  const dec = () => {

    // if(this.props.solution == null){
      props.decGelOrientation({id: props.id})
    // } else {
    //   this.makeToast(
    //     "WARNING",
    //     "You cannot rotate the gel once buffer has been added to the box.",
    //     "Buffer in gel box!"
    //   );
    // }

  }

  return (
    <div className={`${props.className}_block`}>
      <div className="gel-position-controls">
        <p>{t("OrientateLabel.string")}</p>
        <div className="control-wrapper">
          <button tabIndex={0} onClick={(e)=>inc(e)}>
            <img alt={t("RotateClockwise.string")} src={RotateLeft} />
          </button>
          <button tabIndex={0} onClick={(e)=>dec(e)}>
            <img alt={t("RotateAntiClockwise.string")} src={RotateRight} />
          </button>
        </div>
      </div>
    </div>
  );
}

OrientationControlBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Orientationd Control Yes/No
   */
  gelOrientation: PropTypes.int,
};

OrientationControlBlock.defaultProps = {};
